import { Col, message, Row } from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import { connect, useSelector } from "react-redux";
import {
  addSkills,
  getNextSkills,
  fetchAllSkills,
} from "../../Redux/Consultant/reducer";
import {
  LoadingOutlined,
  PlusOutlined,
  CheckOutlined,
  CloseCircleFilled,
} from "@ant-design/icons";
import {
  StyledButton,
  StyledLink,
  StyledCheckTag,
} from "../../styled-components/components";
import SkillCard from "./SkillCard";
import constants from "../../Redux/constants";
import Feedback from "../../Utilities/Feedback";
import SearchBar from "../../Utilities/SearchBar";

const ListSkills = (props) => {
  const [updatingSkills, setUpdatingSkills] = useState(false);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [equalSkillLength, setEqualSkillLength] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [searchSkills, setSearchSkills] = useState([]);
  const [searching, setSearching] = useState(false);
  const { userSkills, allSkillsSubSet, allSkills } = useSelector(
    (state) => state.consultantStore
  );
  const { fetchAllSkills } = props;
  useEffect(() => {
    if (selectedSkills.length > 0) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [selectedSkills]);

  // get the skill and append it to the selectedSkill array
  const addSkill = (skill) => {
    const isSkillAdded = selectedSkills.filter(
      (eachSkill) => eachSkill.id === skill.id
    );
    if (isSkillAdded.length === 0) {
      setSelectedSkills([...selectedSkills, skill]);
    }
  };

  // check the skill if is added to selectedSkills Array
  const isChecked = (skill) => {
    const isSkillAdded = selectedSkills.filter(
      (eachSkill) => eachSkill.id === skill.id
    );
    if (isSkillAdded.length > 0) {
      return true;
    }
    return false;
  };
  const removeSkill = (id) => {
    const skills = selectedSkills.filter((skillId) => skillId !== id);
    setSelectedSkills([...skills]);
  };
  const updateSkills = async () => {
    setUpdatingSkills(true);
    const selectedSkillsId = selectedSkills.map((skill) => skill.id);
    // fetching the Id's and calling the api....
    await props.addSkills(selectedSkillsId);
    const responseStatus = await fetchAllSkills();
    if (responseStatus === constants.status.success) {
      setUpdatingSkills(false);
      setSelectedSkills([]);
      message.success("Skills Updated Successfully!!", 3);
    }
  };
  useEffect(() => {
    if (allSkillsSubSet.length === allSkills.length) {
      setEqualSkillLength(true);
    } else {
      setEqualSkillLength(false);
    }
  }, [allSkillsSubSet, allSkills]);
  const getNextSkills = () => {
    const length = allSkillsSubSet.length;
    const nextItemLength = length + 5;
    props.getNextSkills(nextItemLength);
  };
  const hideSkills = () => {
    props.getNextSkills(5);
    setEqualSkillLength(false);
  };
  const getSearchText = (searchText) => {
    setSearching(true);
    const text = new RegExp(searchText, "i");
    const searchingSkills = allSkills.filter((skill) =>
      skill.name.toString().match(text)
    );
    setSearchSkills([...searchingSkills]);
  };
  const showAllSkills = () => {
    setSearching(false);
  };
  return (
    <Col xs={{ span: 24 }}>
      <Row>
        <Col xl={{ span: 16 }}>
          {updatingSkills ? (
            <Col
              style={{
                background: "#ffffff",
                padding: "4vh",
              }}
            >
              <Feedback
                icon={<LoadingOutlined />}
                title="Updating Skills"
              ></Feedback>
            </Col>
          ) : (
            <Col>
              <SkillCard userSkills={userSkills} />
            </Col>
          )}
        </Col>
        <Col xl={{ span: 8 }}>
          <Col
            style={{
              border: "1px solid #ccc",
              margin: "1vh",
              marginBottom: "2vh",
              borderRadius: "6px",
              background: "white",
              boxShadow: "4px 4px 10px #0a4249",
            }}
          >
            <Row style={{ margin: "1vh" }}>
              <SearchBar
                searchHolder="Search Skills.."
                getSearchText={getSearchText}
                showAllSkills={showAllSkills}
              />
            </Row>
            <Row>
              {/* If Searching then hide all the skills and selected skills */}
              {searching ? (
                <Col>
                  {searchSkills &&
                    searchSkills.map((eachSkill) => (
                      <Row key={eachSkill.id}>
                        <Col key={eachSkill.id}>
                          <StyledCheckTag
                            key={eachSkill.id}
                            data-testid={`tag-${eachSkill.id}`}
                            checked={isChecked(eachSkill)}
                            onClick={() => addSkill(eachSkill)}
                          >
                            {isChecked(eachSkill) ? <CheckOutlined /> : null}
                            {eachSkill.name}
                            {isChecked(eachSkill) ? null : (
                              <PlusOutlined data-testid="submit-addSkill" />
                            )}
                            {isChecked(eachSkill) ? (
                              <CloseCircleFilled
                                data-testid="submit-removeSkill"
                                onClick={() => removeSkill(eachSkill)}
                              />
                            ) : null}
                          </StyledCheckTag>
                        </Col>
                      </Row>
                    ))}
                </Col>
              ) : (
                <Col>
                  <Col>
                    {selectedSkills.length > 0 ? (
                      <Col>
                        {selectedSkills.map((eachSkill) => (
                          <Row key={eachSkill.id}>
                            <Col>
                              <StyledCheckTag
                                key={eachSkill.id}
                                data-testid={`tag-${eachSkill.id}`}
                                checked={isChecked(eachSkill)}
                                onClick={() => addSkill(eachSkill)}
                              >
                                {isChecked(eachSkill) ? (
                                  <CheckOutlined />
                                ) : null}
                                {eachSkill.name}
                                {isChecked(eachSkill) ? null : (
                                  <PlusOutlined data-testid="submit-addSkill" />
                                )}
                                {isChecked(eachSkill) ? (
                                  <CloseCircleFilled
                                    data-testid="submit-removeSkill"
                                    onClick={() => removeSkill(eachSkill)}
                                  />
                                ) : null}
                              </StyledCheckTag>
                            </Col>
                          </Row>
                        ))}
                      </Col>
                    ) : null}
                    <Row>
                      {allSkillsSubSet.map((eachSkill) => (
                        <Row key={eachSkill.id}>
                          <Col>
                            {!isChecked(eachSkill) ? (
                              <StyledCheckTag
                                key={eachSkill.id}
                                data-testid={`tag-${eachSkill.id}`}
                                checked={isChecked(eachSkill)}
                                onClick={() => addSkill(eachSkill)}
                              >
                                {isChecked(eachSkill) ? (
                                  <CheckOutlined />
                                ) : null}
                                {eachSkill.name}
                                {isChecked(eachSkill) ? null : (
                                  <PlusOutlined data-testid="submit-addSkill" />
                                )}
                                {isChecked(eachSkill) ? (
                                  <CloseCircleFilled
                                    data-testid="submit-removeSkill"
                                    onClick={() => removeSkill(eachSkill)}
                                  />
                                ) : null}
                              </StyledCheckTag>
                            ) : null}
                          </Col>
                        </Row>
                      ))}
                    </Row>
                    <Row style={{ padding: "1vh" }}>
                      {equalSkillLength ? (
                        <StyledLink
                          onClick={hideSkills}
                          data-testid="hideSkills"
                        >
                          Hide Skills
                        </StyledLink>
                      ) : (
                        <StyledLink
                          onClick={getNextSkills}
                          data-testid="moreSkills"
                        >
                          More Skills...
                        </StyledLink>
                      )}
                    </Row>
                  </Col>
                </Col>
              )}
            </Row>
            <Row justify="end" style={{ margin: "1vh" }}>
              <StyledButton
                disabled={disabled}
                onClick={updateSkills}
                data-testid="submit-updateSkills"
              >
                Update Skill
              </StyledButton>
            </Row>
          </Col>
        </Col>
      </Row>
    </Col>
  );
};

const mapToReducer = (dispatch) => {
  return {
    fetchAllSkills: () => dispatch(fetchAllSkills()),
    addSkills: (skills) => dispatch(addSkills(skills)),
    getNextSkills: (length) => dispatch(getNextSkills(length)),
  };
};

export default connect(null, mapToReducer)(ListSkills);
